module.exports = __webpack_public_path__ + "assets/media/hand-heart-about.f8a01795.svg";